import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'BusyIndicator',
  setup(__props) {

/* ... */

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_FontAwesomeIcon, {
      class: "busy-indicator",
      icon: "spinner"
    })
  ]))
}
}

})